<template>
  <div class="main-content">
    <i v-show="showCondition" class="el-icon-caret-top" @click="showCondition=false" />
    <div v-show="showCondition" style="display: flex;margin-top: 5px;">
      <el-form v-if="conditionItems.length>0" :inline="true" label-width="100px" style="flex-grow: 1">
        <condition-form-item v-for="(item,index) in conditionItems" :key="index" :item="item" :descriptor-registry="descriptorRegistry" />
      </el-form>
      <div v-else style="flex-grow: 1" />
      <div style="display: flex; flex-direction: column; justify-content: space-between;align-items: flex-end;">
        <span v-if="lastUpdateTime" class="el-form-item__label" style="color: #000000">{{ $t('CargoMsg.Cargo_LastUpdateTime') }}: {{ lastUpdateTime }}</span>
        <div :style="(isZh ? 'width: 240px;' : 'width: 310px;') + 'display: flex;flex-direction: row-reverse;flex-shrink: 0;align-items: flex-end;padding-bottom: 7px;'">
          <el-button no="Back" type="primary" @click="backToOldVersion">{{ $t('CargoMsg.Cargo_BackTopPreviousVersion') }}</el-button>
          <el-button no="DataExport" type="primary" style="margin-right: 10px" @click="exportHandler">{{ $t('CargoMsg.Cargo_DataExport') }}</el-button>
          <el-button no="Query" type="primary" style="margin-right: 5px" @click="toQuery">{{ $t('common.btn.query') }}</el-button>
        </div>
      </div>
    </div>
    <i v-show="!showCondition" class="el-icon-caret-bottom" @click="showCondition=true" />
    <div style="display: flex;flex-direction: column;flex-grow: 1;background: white;">
      <div v-show="!firstPage" style="margin-top: 5px">
        <el-button no="Cargo_Back" type="primary" @click="firstPage=true;report.heightChangeFlag = true">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
        <el-button no="SaveDisplayColumns" type="primary" @click="saveDisplayColumns">{{ $t('Message.SaveDisplayColumns') }}</el-button>
        <el-button no="Setting" type="primary" @click="toConfigColumns">{{ $t('Pricing.Setting') }}</el-button>
      </div>
      <div style="flex: 1;position: relative;margin-top: 5px">
        <div style="position: absolute;width: 100%;height: 100%;">
          <template v-if="dwReportVersion === 1">
            <dw-ag-grid
              v-if="firstPage&&report.headers.length>0"
              ref="dwReport"
              key="dwReport"
              :config-module="reportConfigModule"
              :headers="reportHeaders"
              :row-data="report.rowData"
              :filter-menu-items="filterMenuItems"
              @cellClick="onCellClick"
            />
            <dw-ag-grid
              v-if="!firstPage&&reportDetail.headers.length>0"
              ref="dwReportDetail"
              key="dwReportDetail"
              :config-module="reportDetailConfigModule"
              :headers="reportDetail.headers"
              :row-data="reportDetail.rowData"
              :cell-class-name="onDetailCellClassName"
              :sub-sum-disiplay-all="false"
              :filter-menu-items="filterMenuItems"
              @cellClick="onDetailCellClick"
            />
          </template>
          <template v-else>
            <dw-report
              v-show="firstPage&&report.headers.length>0"
              ref="dwReport"
              :headers="reportHeaders"
              :row-data="report.rowData"
              :height-change-flag.sync="report.heightChangeFlag"
              @cellClick="onCellClick"
            />
            <dw-report
              v-show="!firstPage&&reportDetail.headers.length>0"
              ref="dwReportDetail"
              :headers="reportDetail.headers"
              :row-data="reportDetail.rowData"
              :cell-class-name="onDetailCellClassName"
              :sub-sum-disiplay-all="false"
              :height-change-flag.sync="reportDetail.heightChangeFlag"
              @cellClick="onDetailCellClick"
            />
          </template>
        </div>
      </div>
    </div>
    <!-- 用于打开新页面，并以post方式提交 -->
    <form ref="form" :action="fileUrl" target="_blank" method="post" style="display:none">
      <input v-for="item in fileFormEntries" :key="item[0]" :name="item[0]" :value="item[1]">
    </form>
    <export-operation-dialog :visible.sync="exportOperationDialog.visible" :prefix="exportOperationDialogPrefix" @export="doExport()" />
    <column-config-dialog
      :visible.sync="columnConfigDialog.visible"
      :descriptor-registry="descriptorRegistry"
      :report-id="reportId"
      :fact-table-id="columnConfigDialog.factTableId"
      :fact-table-column-id="columnConfigDialog.factTableColumnId"
      :fact-table-number="columnConfigDialog.factTableNumber"
      @enter="showReportDetail"
    />
  </div>
</template>

<script>
import dwReport from '@/components/Cargo/Report/dwReport'
import dwAgGrid from '@/components/Cargo/Report/dwAgGrid'
import ConditionFormItem from '@/views/cargo/v0/Analysis/components/ConditionFormItem'
import ExportOperationDialog from '@/views/cargo/v0/Analysis/components/ExportOperationDialog'
import ColumnConfigDialog from '@/views/cargo/v0/Analysis/components/ColumnConfigDialog'
import x2js from 'x2js'
import { mapGetters } from 'vuex'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import StrUtils from '@/utils/StrUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getCargoJumpUrl } from '@/utils/permission'
import * as dw from '@/api/dw'
import { queryJobNoLinkFunc } from '@/api/booking/job'
import { cache } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'ReportItemDetail',
  components: { dwReport, dwAgGrid, ConditionFormItem, ExportOperationDialog, ColumnConfigDialog },
  props: {
    reportId: { type: String, required: true },
    descriptorRegistry: { type: Object, default: null }
  },
  data() {
    return {
      showCondition: true,
      conditionItems: [],
      sourceVariables: [
        'sessionId',
        'param',
        'op',
        'reportId',
        'officeCode',
        'tenantId',
        'departmentCode',
        'level',
        'userId',
        'userChineseName'
      ], // 原始参数
      drillDownVariables: {}, // 记住上次选择的参数
      firstPage: true,
      report: {
        factTableId: '',
        description: '',
        headers: [],
        rowData: [],
        heightChangeFlag: false
      },
      selectedRow: null,
      selectedHeaderIndex: -1,
      reportDetail: {
        factTableNumber: '',
        factTableColumnId: '',
        factTableId: '',
        headers: [],
        rowData: [],
        heightChangeFlag: false
      },
      fileUrl: '',
      fileFormEntries: [],
      exportOperationDialog: {
        visible: false
      },
      columnConfigDialog: {
        visible: false,
        factTableId: '',
        factTableColumnId: '',
        factTableNumber: ''
      },
      lastUpdateTime: '', // 最后更新时间
      dwReportVersion: Number(cache.hqConfig.get('DWReportVersion')) || 0 // DW报表版本
    }
  },
  computed: {
    ...mapGetters([
      'language',
      'userInfo',
      'currentOfficeId',
      'currentDeptId'
    ]),
    exportOperationDialogPrefix() {
      return this.firstPage ? '' : 'DETAIL_'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    reportHeaders() {
      return Array.from(this.report.headers, p => ({ ...p, label: p.label.replace(/\$\{branchLevel[1-9]\d*\}/, '') }))
    },
    reportConfigModule() {
      const hash = this.hashStringToNumber('report' + this.reportId)
      return hash > 0 ? '-' + hash : String(hash)
    },
    reportDetailConfigModule() {
      const hash = this.hashStringToNumber('reportDetail' + this.reportId)
      return hash > 0 ? '-' + hash : String(hash)
    }
  },
  watch: {
    reportId: {
      immediate: true,
      handler() {
        dw.repositoryServlet({ operate: 'findReport', reportId: this.reportId }).then(res => {
          if (res.content) {
            // eslint-disable-next-line new-cap
            const obj = new x2js().xml2js(res.content)
            const report = obj.report
            this.conditionItems = this.getReportParamter(report)
            if (this.conditionItems.length === 0) {
              this.toQuery()
            } else {
              this.queryLastUpdateTime(report._factTableId)
            }
          } else {
            this.conditionItems = []
            this.report.factTableId = ''
            this.report.description = ''
            this.report.headers = []
            this.report.rowData = []
          }
        })
      }
    },
    showCondition() {
      this.report.heightChangeFlag = true
      this.reportDetail.heightChangeFlag = true
    }
  },
  created() {
    if (this.reportId) {
      const loading = getLoading4Cxt(this)
      dw.queryPersonUiConfig({ configNamePrefix: this.reportId }).then(res => {
        for (const item of res.content) {
          LocalStorageUtilsNew.setConfiguration(item.configName, item.configContent)
        }
      }).finally(() => {
        loading.close()
      })
    }
  },
  activated() {
    this.report.heightChangeFlag = true
    this.reportDetail.heightChangeFlag = true
  },
  methods: {
    getReportParamter(report) {
      const result = []
      const params = this.getFilterParamters(report)
      const placeHolders = this.getPlaceHolders(report)
      for (const item of params) {
        for (const placeHolder of placeHolders) {
          if (item.placeHolder === placeHolder.code) {
            result.push({
              code: item.placeHolder, // code唯一标示
              displayName: item.name + '：', // 显示列
              value: placeHolder.defaultValue, // 默认值
              dataType: placeHolder.dataType, // 数值类型
              factTableId: item.factTableId, // 业务类型
              dimensionId: item.dimensionId, // 分组字段
              columnId: item.columnId, // 详细
              selectAllBranch: item.selectAllBranch,
              isRange: placeHolder.isRange, // 对于日期类型(是否合并标识)
              isMore: item.isMore, // 是否可以选择多个值(销售,操作等等)
              displayByLevel: item.displayByLevel,
              returnValue: '' // 输入框返回值，如果存在，优先取这个
            })
          }
        }
      }
      return result
    },
    getFilterParamters(report) {
      const result = []
      const set = new Set() // 用于去重
      let facts = report.facts
      if (!facts) {
        return result
      }
      if (!(facts instanceof Array)) {
        facts = [facts]
      }
      for (const fact of facts) {
        let filter = fact.filter
        if (!filter) {
          continue
        }
        if (filter instanceof Array) {
          filter = [...filter]
        } else {
          filter = [filter]
        }
        for (let i = 0; i < filter.length; ++i) {
          const filterItem = filter[i]
          if (filterItem.filter) {
            if (filterItem.filter instanceof Array) {
              filter.splice(i + 1, 0, ...filterItem.filter)
            } else {
              filter.splice(i + 1, 0, filterItem.filter)
            }
          }
          const firstChild = filterItem[Object.keys(filterItem).find(p => !p.startsWith('_'))]
          if (!firstChild) {
            continue
          }
          let parameter = firstChild.parameter
          if (!parameter) {
            continue
          }
          if (!(parameter instanceof Array)) {
            parameter = [parameter]
          }
          for (const parameterItem of parameter) {
            if (set.has(parameterItem._placeHolder)) {
              continue
            }
            set.add(parameterItem._placeHolder)
            result.push({
              placeHolder: parameterItem._placeHolder,
              name: parameterItem._name,
              displayName: parameterItem._name,
              factTableId: report._factTableId,
              dimensionId: filterItem._dimensionId,
              columnId: filterItem._columnId,
              selectAllBranch: filterItem._SelectAllBranch ? filterItem._SelectAllBranch.toLowerCase() === 'true' : false,
              isMore: filterItem.hasOwnProperty('in') || filterItem.hasOwnProperty('notIn'),
              displayByLevel: filterItem._displayByLevel === '1'
            })
          }
        }
      }
      return result
    },
    getPlaceHolders(report) {
      const result = []
      let placeHolder = report.placeHolder
      if (!placeHolder) {
        return result
      }
      if (!(placeHolder instanceof Array)) {
        placeHolder = [placeHolder]
      }
      for (const item of placeHolder) {
        const obj = {
          code: item._code,
          name: item._name,
          displayName: item._name,
          dataType: Number(item._dataType),
          defaultValue: item._defaultValue
        }
        if (item.hasOwnProperty('_isRange') && item._isRange) {
          obj.isRange = item._isRange === 'true'
        }
        result.push(obj)
      }
      return result
    },
    toQuery() {
      const officeId = this.$store.getters.currentOfficeId
      const officeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', officeId, 'englishName')
      const userInfo = this.$store.getters.userInfo
      const params = {
        operate: 'run',
        reportId: this.reportId,
        officeId,
        officeCode,
        tenantId: userInfo.tenantId,
        departmentId: this.$store.getters.currentDeptId || 0,
        departmentCode: this.$store.getters.currentDept.englishName || '',
        level: 1,
        userId: userInfo.userId,
        userChineseName: userInfo.chineseName
      }
      for (const item of this.conditionItems) {
        // 不能覆盖原始参数
        if (this.sourceVariables.includes(item.code)) {
          continue
        }
        this.drillDownVariables[item.code] = this.encodeURIComponentForSpecial(item.returnValue || item.value)
        params[item.code] = this.encodeURIComponentForSpecial(item.returnValue || item.value)
      }
      const loading = getLoading4Cxt(this)
      dw.runtimeServlet(params).then(res => {
        const data = res.content
        this.report.factTableId = data.factTableId
        this.report.description = data.description
        for (let i = 0; i < data.headers.length; ++i) {
          const item = data.headers[i]
          item.name = this.filterIllegalChar(item.label) + i
        }
        this.adjustColumnDisplayFormatter(data.headers)
        this.report.headers = data.headers
        const matrix = data.groups.length > 0 ? this.readGroupByMatrix(data.groups) : []
        this.report.rowData = []
        for (const arr of matrix) {
          const row = {}
          for (let j = 0; j < this.report.headers.length; ++j) {
            row[this.report.headers[j].name] = arr[j] || ''
          }
          this.report.rowData.push(row)
        }
        this.queryLastUpdateTime(this.report.factTableId)
      }).finally(() => {
        loading.close()
      })
    },
    // 对特殊字符进行转义（排除中文、非字符串...）
    encodeURIComponentForSpecial(source) {
      if (typeof source === 'string') {
        let result = ''
        for (let i = 0; i < source.length; ++i) {
          const charCode = source.charCodeAt(i)
          if (charCode < 256) {
            result += encodeURIComponent(source[i])
          } else {
            result += source[i]
          }
        }
        return result
      }
      return source
    },
    // 过滤（属性名）非法字符
    filterIllegalChar(str) {
      return str.replace(/\./g, '').replace(/'/g, '_')
    },
    // 调整列的显示格式
    adjustColumnDisplayFormatter(headers) {
      for (const header of headers) {
        if (header.columnId === 'cargo.fact.charge.exchageRate' || header.columnId === 'cargo.fact.charge.invoiceRate') {
          header.displayPrecision = 8
        }
      }
    },
    /**
     * 以二维数组格式读取group
     */
    readGroupByMatrix(group, result = [], multipleResult = null) {
      if (!multipleResult) {
        multipleResult = [result]
      }
      if (group instanceof Array) {
        if (group.length > 0) {
          const resultBackup = [...result]
          this.readGroupByMatrix(group[0], result, multipleResult)
          for (let i = 1; i < group.length; ++i) {
            const newResult = [...resultBackup]
            multipleResult.push(newResult)
            this.readGroupByMatrix(group[i], newResult, multipleResult)
          }
        }
      } else {
        result.push(group.value)
        if (group.groups) {
          this.readGroupByMatrix(group.groups, result, multipleResult)
        } else if (group.cells) {
          result.push(...group.cells)
        }
      }
      return multipleResult
    },
    exportHandler() {
      if (LocalStorageUtilsNew.getConfiguration(this.exportOperationDialogPrefix + 'NOT_REMIND_EXPORT_OPERATION')) {
        this.doExport()
      } else {
        this.exportOperationDialog.visible = true
      }
    },
    // 计算每列最大宽度，用于导出Excel时定义列宽度
    getMaxWidthRow(grid) {
      const maxWidthList = []
      const columunArray = grid.headers// 所有列
      const rowArray = grid.rowData// 所有行
      if (columunArray.length > 0 && rowArray.length > 0) {
        for (let i = 0; i < columunArray.length; i++) {
          let orgionlength = 0
          for (let j = 0; j < rowArray.length; j++) {
            const value = rowArray[j][columunArray[0].name]
            if (value) {
              const text = String(value)
              if (!text) {
                if (StrUtils.isChinese(text) || StrUtils.isEnglish(text)) {
                  const length = text.length
                  if (orgionlength < length) {
                    orgionlength = length
                  }
                } else {
                  // 判断是否日期类型
                  if (text.indexOf('.') < 0 || text.indexOf(',') < 0) {
                    if (new Date(text)) {
                      const dateLength = text.length
                      if (orgionlength < dateLength) {
                        orgionlength = dateLength
                      }
                    }
                  }
                }
              }
            }
          }
          maxWidthList.push(orgionlength)
        }
      }
      return maxWidthList
    },
    doExport(data) {
      let exportDesc = ''
      let mergeGroup = ''
      if (data) {
        exportDesc = data.exportDesc ? 'true' : 'false'
        mergeGroup = data.mergeGroup ? 'true' : 'false'
      } else {
        exportDesc = LocalStorageUtilsNew.getConfiguration(this.exportOperationDialogPrefix + 'IS_EXPORT_OPERATION') ? 'true' : 'false'
        mergeGroup = !LocalStorageUtilsNew.getConfiguration(this.exportOperationDialogPrefix + 'IS_MERGE_GROUP') ? 'true' : 'false'
      }
      if (this.firstPage) {
        const userInfo = this.$store.getters.userInfo
        const officeId = this.$store.getters.currentOfficeId
        const officeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', officeId, 'englishName')
        const params = {
          sessionId: userInfo.sessionId,
          operate: 'exportReport',
          reportId: this.reportId,
          exportDesc,
          mergeGroup,
          officeId,
          officeCode,
          departmentId: this.$store.getters.currentDeptId || 0,
          departmentCode: this.$store.getters.currentDept.englishName || '',
          tenantId: userInfo.tenantId,
          userId: userInfo.userId,
          userChineseName: userInfo.chineseName,
          level: 1,
          ...this.drillDownVariables
        }
        const header = this.$refs.dwReport.sortHeader
        const sortType = this.$refs.dwReport.sortType
        const sortHeaders = this.$refs.dwReport.sortHeaders
        const sortTypes = this.$refs.dwReport.sortTypes
        if (header && sortType) {
          // params.sortColumnId = header.columnId
          // params.sortDimensionId = header.dimensionId
          params.sortIndex = this.report.headers.findIndex(p => p.name === header.name)
          params.sortType = sortType === 'descending' ? 2 : 1
          if (sortHeaders && sortTypes) {
            params.sortIndexs = Array.from(sortHeaders, item => this.report.headers.findIndex(p => p.name === item.name)).join(',')
            params.sortTypes = Array.from(sortTypes, item => item === 'descending' ? 2 : 1).join(',')
          }
        }
        params.maxWidth = this.getMaxWidthRow(this.report)
        if (!this.isZh) {
          params.filename = this.$route.query.title
        }
        params.language = this.isZh ? 'zh_CN' : 'en_US'
        if (data && data.titles) {
          params.titles = data.titles.join(',')
        }
        this.fileUrl = dw.getRuntimeServletUrl()
        this.fileFormEntries = Object.entries(params)
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      } else {
        const userInfo = this.$store.getters.userInfo
        const officeId = this.$store.getters.currentOfficeId
        const officeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', officeId, 'englishName')
        const params = {
          sessionId: userInfo.sessionId,
          operate: 'exportDrillDownResult',
          param: this.encodeURIComponentForSpecial(this.getDrillDownParam(this.selectedRow, this.selectedHeaderIndex)),
          exportDesc,
          mergeGroup,
          officeId,
          officeCode,
          tenantId: userInfo.tenantId,
          departmentId: this.$store.getters.currentDeptId || 0,
          departmentCode: this.$store.getters.currentDept.englishName || '',
          userId: userInfo.userId,
          userChineseName: userInfo.chineseName,
          level: 2,
          ...this.drillDownVariables
        }
        const header = this.$refs.dwReportDetail.sortHeader
        const sortType = this.$refs.dwReportDetail.sortType
        const sortHeaders = this.$refs.dwReportDetail.sortHeaders
        const sortTypes = this.$refs.dwReportDetail.sortTypes
        if (header && sortType) {
          // params.sortColumnId = header.columnId
          // params.sortDimensionId = header.dimensionId
          params.sortIndex = this.reportDetail.headers.findIndex(p => p.name === header.name)
          params.sortType = sortType === 'descending' ? 2 : 1
          if (sortHeaders && sortTypes) {
            params.sortIndexs = Array.from(sortHeaders, item => this.reportDetail.headers.findIndex(p => p.name === item.name)).join(',')
            params.sortTypes = Array.from(sortTypes, item => item === 'descending' ? 2 : 1).join(',')
          }
        }
        params.maxWidth = this.getMaxWidthRow(this.reportDetail)
        if (!this.isZh) {
          params.filename = this.$route.query.title
        }
        params.language = this.isZh ? 'zh_CN' : 'en_US'
        if (data && data.titles) {
          params.titles = data.titles.join(',')
        }
        this.fileUrl = dw.getRuntimeServletUrl()
        this.fileFormEntries = Object.entries(params)
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      }
    },
    backToOldVersion() {
      const jumpCargoUrl = getCargoJumpUrl({
        code: 'StarSchemaModule',
        reportId: this.reportId,
        language: this.language,
        sessionId: this.userInfo.sessionId,
        branchId: this.currentOfficeId,
        departmentId: this.currentDeptId
      })
      window.open(jumpCargoUrl, '_blank')
    },
    async onCellClick(row, header, headerIndex) {
      if (!this.$checkPermission(['role_StarSchemaModule_drillDown'])) {
        this.$message.warning(this.$t('Message.NoPermissionViewSecondaryTable'))
        return
      }
      this.selectedRow = row
      this.selectedHeaderIndex = headerIndex
      this.reportDetail.factTableNumber = header.id
      this.reportDetail.factTableColumnId = header.dimensionId ? header.dimensionId : header.columnId
      if (this.reportDetail.factTableColumnId) {
        const lastDotIndex = this.reportDetail.factTableColumnId.lastIndexOf('.')
        this.reportDetail.factTableId = this.reportDetail.factTableColumnId.substr(0, lastDotIndex)
      } else {
        this.reportDetail.factTableId = ''
      }
      this.showReportDetail()
    },
    showReportDetail() {
      const officeId = this.$store.getters.currentOfficeId
      const officeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', officeId, 'englishName')
      const userInfo = this.$store.getters.userInfo
      const params = {
        operate: 'drilldown',
        param: this.encodeURIComponentForSpecial(this.getDrillDownParam(this.selectedRow, this.selectedHeaderIndex)),
        officeId,
        officeCode,
        tenantId: userInfo.tenantId,
        departmentId: this.$store.getters.currentDeptId || 0,
        departmentCode: this.$store.getters.currentDept.englishName || '',
        reportId: this.reportId,
        level: 2,
        userId: userInfo.userId,
        userChineseName: userInfo.chineseName,
        ...this.drillDownVariables
      }
      const loading = getLoading4Cxt(this)
      dw.runtimeServlet(params).then(res => {
        const data = res.content
        this.adjustColumnDisplayFormatter(data.headers)
        this.reportDetail.headers = data.headers
        for (const item of data.headers) {
          item.name = this.filterIllegalChar(item.label)
        }
        this.reportDetail.rowData = []
        for (const item of data.rows) {
          const row = {}
          for (let j = 0; j < this.reportDetail.headers.length; ++j) {
            const header = this.reportDetail.headers[j]
            if (!header.dataType) {
              header.dataType = this.getDataType(item.cells[j])
            } else if (header.dataType === 'Integer') {
              if (this.getDataType(item.cells[j]) === 'Double') {
                header.dataType = 'Double'
              }
            }
            row[header.name] = item.cells[j] || ''
          }
          this.reportDetail.rowData.push(row)
        }
        this.firstPage = false
      }).finally(() => {
        loading.close()
      })
    },
    getDataType(value) {
      if (typeof value === 'number') {
        if (value * 10 % 10 > 0) {
          return 'Double'
        } else {
          return 'Integer'
        }
      } else if (typeof value === 'string') {
        return 'String'
      } else if (typeof value === 'boolean') {
        return 'Boolean'
      }
      return ''
    },
    getDrillDownParam(row, headerIndex) {
      let result = `<drillDownParam reportId="${this.reportId}">`
      result = this.addDrillDownHeader(result)
      const headers = this.report.headers
      let i = 0
      let lastHeader = null
      let preHeader = null
      for (const header of headers) {
        if (headerIndex < i) {
          break
        }
        if (!header.display) {
          continue
        }
        lastHeader = header
        if (header.group) {
          if (header.label.match(/\$\{branchLevel[1-9]\d*\}/)) {
            if (!(preHeader && preHeader.label.match(/\$\{branchLevel[1-9]\d*\}/) && preHeader.columnId === header.columnId && preHeader.dimensionId === header.dimensionId)) {
              result += `\n<cellParam columnId="${header.columnId}" dimensionId="${header.dimensionId}" isGroup="${header.group}" headerIndex="${header.id}" value=""/>`
              preHeader = header
            }
          } else {
            const value = this.getActualValueIfBoolean(header, row[header.name])
            const text = row.subSum || row.sum ? '' : String(value)
            result += `\n<cellParam columnId="${header.columnId}" dimensionId="${header.dimensionId}" isGroup="${header.group}" headerIndex="${header.id}" value="${text.replace(/&/g, '&amp;').replaceAll('"', '&quot;')}"/>`
            preHeader = header
          }
        }
        ++i
      }
      if (lastHeader && !lastHeader.group) {
        result += `\n<cellParam columnId="${lastHeader.columnId}" dimensionId="${lastHeader.dimensionId}" value="" headerIndex="${lastHeader.id}" />`
      }
      result += '\n</drillDownParam>'
      console.log('result=================', result)
      return result
    },
    getActualValueIfBoolean(header, value) {
      if (header.dataType === 'Boolean') {
        if (value === this.$t('Analysis.Yes')) {
          return 1
        } else {
          return 0
        }
      }
      return value
    },
    addDrillDownHeader(xml) {
      const ids = LocalStorageUtilsNew.getConfiguration(this.reportId + this.reportDetail.factTableColumnId + '_' + this.reportDetail.factTableNumber)
      if (ids) {
        for (const id of ids) {
          xml = this.processColumn(xml, id.split(','))
        }
      }
      return xml
    },
    processColumn(xml, ids) {
      for (const factTable of this.descriptorRegistry.factTables) {
        const { facts, details, dimensions } = factTable
        const factDetails = [...facts, ...details]
        for (const item of factDetails) {
          if (item.id === ids[0]) {
            xml += `\n<header columnId="${item.id}" dataType="${item.dataTypeString || item.dataType}" dimensionId="" name="${item.name}"/>`
          }
        }
        for (const item of dimensions) {
          if (item.id === ids[0]) {
            if (ids.length > 1) {
              const dimensionTable = this.descriptorRegistry.dimensionTables.find(p => p.id === item.dataTypeString)
              if (dimensionTable) {
                const columns = dimensionTable.columns
                for (const column of columns) {
                  if (column.id === ids[1]) {
                    xml += `\n<header columnId="${column.id}" dataType="${column.dataTypeString || column.dataType}" dimensionId="${item.id}" name="${item.name}[${column.name}]"/>`
                    break
                  }
                }
              }
            } else {
              xml += `\n<header columnId="${item.id}" dataType="${item.dataTypeString || item.dataType}" dimensionId="" name="${item.name}"/>`
            }
          }
        }
      }
      return xml
    },
    onDetailCellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.label === this.$t('Analysis.WorkflowNumber') && !row.subSum && !row.sum) {
        return 'link'
      }
      return ''
    },
    onDetailCellClick(row, header, headerIndex) {
      if ((header.columnId.endsWith('.jobno') || header.columnId.endsWith('.dmnjobno')) && !row.subSum && !row.sum) {
        const jobNo = row[header.name]
        if (jobNo) {
          queryJobNoLinkFunc({ jobNo }).then(res => {
            const data = res.data
            if (!data) return
            if (this.$store.getters.isAdmin) {
              this.jumpBusinessModule(data)
            } else {
              if (this.getBusinessModulePermission(data.lob)) { // 有业务模块权限
                this.jumpBusinessModule(data)
              } else if (this.$checkPermission(['module_ACVerify'])) { // 有财务模块权限
                this.$router.push({ name: 'FinanceManage', params: { jobNo: data.jobNo }})
              } else {
                this.$message.warning(this.$t('CargoMsg.Cargo_NoPermissionForModule'))
                return
              }
            }
          })
        }
      }
    },
    saveDisplayColumns() {
      const configName = this.reportId + this.reportDetail.factTableColumnId + '_' + this.reportDetail.factTableNumber
      const configContent = LocalStorageUtilsNew.getConfiguration(configName, 'string') || '[]'
      dw.savePersonUiConfig({ configName, configContent }).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      })
    },
    toConfigColumns() {
      if (!this.$checkPermission(['button_StarSchemaModule_columnConfig'])) {
        this.$message.warning(this.$t('Message.NoPermissionSetSecondaryTableColumns'))
        return
      }
      this.columnConfigDialog.factTableId = this.reportDetail.factTableId
      this.columnConfigDialog.factTableColumnId = this.reportDetail.factTableColumnId
      this.columnConfigDialog.factTableNumber = this.reportDetail.factTableNumber
      this.columnConfigDialog.visible = true
    },
    // 跳转业务模块
    jumpBusinessModule(data) {
      switch (data.lob) {
        case SystemConstants.AI.code:
          this.$router.push({ name: 'AiBooking', params: { jobNo: data.jobNo, branchId: data.opOffice || data.salesOffice }})
          break
        case SystemConstants.AE.code:
          this.$router.push({ name: 'AeBooking', query: { jobNo: data.jobNo }, params: { branchId: data.opOffice || data.salesOffice }})
          break
        case SystemConstants.SI.code:
          this.$router.push({ name: 'SiBooking', params: { jobNo: data.jobNo, branchId: data.opOffice || data.salesOffice }})
          break
        case SystemConstants.SE.code:
          this.$router.push({ name: 'SeaBooking', query: { jobNo: data.jobNo }, params: { branchId: data.opOffice || data.salesOffice }})
          break
        case SystemConstants.RE.code:
        case SystemConstants.RI.code:
          this.$router.push({ name: 'ReBooking', query: { jobNo: data.jobNo }, params: { branchId: data.opOffice || data.salesOffice }})
          break
        case SystemConstants.IE.code:
          this.$router.push({ name: 'IEBooking', query: { jobNo: data.jobNo }, params: { branchId: data.opOffice || data.salesOffice }})
          break
      }
    },
    getBusinessModulePermission(lob) {
      if (lob === SystemConstants.SE.code) {
        return this.$checkPermission(['module_fmBookingNew'])
      } else if (lob === SystemConstants.SI.code) {
        return this.$checkPermission(['module_SIBOOKING'])
      } else if (lob === SystemConstants.AE.code) {
        return this.$checkPermission(['module_AEBooking'])
      } else if (lob === SystemConstants.AI.code) {
        return this.$checkPermission(['module_AIBooking'])
      } else if ([SystemConstants.RI.code, SystemConstants.RE.code].includes(lob)) {
        return this.$checkPermission(['module_RailwayExport'])
      } else if (lob === SystemConstants.IE.code) {
        return this.$checkPermission(['module_IEBooking'])
      }
      return false
    },
    queryLastUpdateTime(factTableId) {
      if (!factTableId) return
      dw.queryLastUpdateTime({ factTableId: factTableId, tenantId: this.$store.getters.tenantId }).then(res => {
        this.lastUpdateTime = res.content || ''
      }).catch(() => {
        this.lastUpdateTime = ''
      })
    },
    hashStringToNumber(str) {
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i)
        hash = (hash << 5) - hash + char
        hash |= 0 // Convert to 32bit integer
      }
      return hash
    },
    filterMenuItems(menus) {
      const exportExcelCurrentPage = `${this.$t('SeaExport.ExportToExcel')}(${this.$t('Message.CurrentPage')})`
      const result = []
      for (const menu of menus) {
        if (menu.name.indexOf(exportExcelCurrentPage) > -1) {
          result.push({
            name: exportExcelCurrentPage,
            action: () => {
              if (this.firstPage ? this.$refs.dwReport.hasRowGroup : this.$refs.dwReportDetail.hasRowGroup) {
                menu.action()
              } else {
                const titles = this.firstPage ? this.$refs.dwReport.getAllDisplayedTitle() : this.$refs.dwReportDetail.getAllDisplayedTitle()
                this.doExport({ exportDesc: false, mergeGroup: true, titles })
              }
            }
          })
        } else if (menu.name.indexOf(this.$t('Message.ColumnSettings')) > -1) {
          result.push(menu)
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.el-icon-caret-top,
.el-icon-caret-bottom {
  font-size: 20px;
  line-height: 15px;
  text-align: center;
  background: white;
}
.main-content::v-deep {
  .dw-report.el-table {
    td.el-table__cell.link {
      color: #3300ff;
      text-decoration: underline;
      cursor: pointer;
      background: #ccffff;
    }
  }
}
</style>
